import { Button, Card, Col, Form, Input, Row, Typography, DatePicker } from "antd";
import styles from "./AddProdCat.module.css";
import dayjs from "dayjs";

import { Fragment, useState } from "react";

import { useDispatch } from "react-redux";
import { addProductCurrency } from "../../redux/actions/productCurrency/addProductCurrencyAction";
import UploadMany from "../Card/UploadMany";

const formatPayload = (values) => {
	const payload = { ...values };
	if (values.effective_from_date) {
		if (dayjs.isDayjs(values.effective_from_date)) {
			payload.effective_from_date = values.effective_from_date.format("YYYY-MM-DD");
		} else if (values.effective_from_date?.format) {
			payload.effective_from_date = values.effective_from_date.format("YYYY-MM-DD");
		} else {
			payload.effective_from_date = dayjs(values.effective_from_date).format("YYYY-MM-DD");
		}
	}
	return payload;
};

const AddProductCurrency = ({ onSuccess = null, inModal = false, onCancel = null }) => {
	const dispatch = useDispatch();
	const { Title } = Typography;

	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const onClick = () => setLoading(true);

	const onFinish = async (values) => {
		try {
			const payload = formatPayload(values);
			const resp = await dispatch(addProductCurrency(payload));
			if (resp && resp.message === "success") {
				setLoading(false);
				form.resetFields();
				if (onSuccess) onSuccess();
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			console.log(error?.message || error || "An error occurred");
		}
	};

	const onFinishFailed = (errorInfo) => {
		setLoading(false);
		console.log("Failed:", errorInfo);
	};

	const formContent = (
		<Form
			form={form}
			className=''
			name='basic'
			labelCol={{ span: inModal ? 8 : 7 }}
			wrapperCol={{ span: inModal ? 16 : 16 }}
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete='off'
		>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Name'
				name='name'
				rules={[{ required: true, message: "Please enter currency name!" }]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Symbol'
				name='symbol'
				rules={[{ required: true, message: "Please enter currency symbol!" }]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Conversion Rate'
				name='conversion'
				rules={[{ required: true, message: "Please enter currency conversion rate!" }]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Effective From Date'
				name='effective_from_date'
				tooltip="Currency conversion rate will be effective from this date"
			>
				<DatePicker
					style={{ width: "100%" }}
					format="DD-MMM-YYYY"
					placeholder="Select effective from date (optional)"
				/>
			</Form.Item>
			<Form.Item
				style={{ marginBottom: inModal ? 0 : "10px" }}
				className={!inModal ? styles.addProdCatBtnContainer : undefined}
				wrapperCol={inModal ? { offset: 8, span: 16 } : undefined}
			>
				{inModal ? (
					<div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
						<Button
							loading={loading}
							onClick={onClick}
							htmlType='submit'
							shape='round'
							style={{ backgroundColor: "#52c41a", borderColor: "#52c41a", color: "#fff" }}
						>
							Add Currency
						</Button>
						{onCancel && (
							<Button type="primary" danger shape="round" onClick={onCancel}>
								Cancel
							</Button>
						)}
					</div>
				) : (
					<Button loading={loading} onClick={onClick} type='primary' htmlType='submit' shape='round'>
						Add Currency
					</Button>
				)}
			</Form.Item>
		</Form>
	);

	if (inModal) return formContent;

	return (
		<Fragment>
			<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='rounded column-design'>
					<Card bordered={false} className='criclebox h-full'>
						<Title level={4} className="text-center" style={{ backgroundColor: '#dadada', padding: '10px', margin: '0 !important' }}>
							Add Product Currency
						</Title>
						{formContent}
					</Card>
				</Col>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='rounded column-design'>
					<Card bordered={false} className={styles.importCsvCard}>
						<Title level={4} className='m-2 text-center'>Import From CSV</Title>
						<UploadMany urlPath="product-currency" onSuccess={onSuccess} />
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default AddProductCurrency;
